module.exports = __webpack_public_path__ + "static/vaRefinancebg-2e9c94776e74004ccc4b02cde83bcc52.jpg";